/** Formatting helpers for the Payment Reconciliation page. */

export function formatMoney(value: number | null | undefined, currency = 'EUR'): string {
    if (value === null || value === undefined || isNaN(Number(value))) return '–';
    return new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(value));
}

export function formatDate(value: string | null | undefined): string {
    if (!value) return '–';
    // value is already yyyy-mm-dd from the API
    const [y, m, d] = value.slice(0, 10).split('-');
    if (!y || !m || !d) return value;
    return `${d}.${m}.${y}`;
}

const STATUS_STYLES: Record<string, string> = {
    Open: 'bg-slate-100 text-slate-700',
    PartiallyPaid: 'bg-amber-100 text-amber-800',
    Paid: 'bg-emerald-100 text-emerald-800',
    WrittenOff: 'bg-slate-200 text-slate-600',
    Unmatched: 'bg-rose-100 text-rose-800',
    PartiallyMatched: 'bg-amber-100 text-amber-800',
    Matched: 'bg-emerald-100 text-emerald-800',
    OnAccount: 'bg-sky-100 text-sky-800',
    NonCustomer: 'bg-violet-100 text-violet-800',
};

export function statusBadgeClass(status: string): string {
    return STATUS_STYLES[status] ?? 'bg-slate-100 text-slate-700';
}

const AGING_STYLES: Record<string, string> = {
    current: 'text-emerald-700',
    '1-30': 'text-amber-700',
    '31-60': 'text-orange-700',
    '61-90': 'text-rose-700',
    '90+': 'text-rose-900 font-semibold',
    paid: 'text-slate-400',
    unknown: 'text-slate-400',
};

export function agingClass(bucket: string): string {
    return AGING_STYLES[bucket] ?? 'text-slate-600';
}
